
theme.BlogTemplateSection = new function () {
  this.onSectionLoad = function (container) {
    this.namespace = theme.namespaceFromSection(container);
    this.$container = $(container);

    // filter dropdown
    this.$container.on('click' + this.namespace, '.link-dropdown__button', theme.toggleLinkDropdownButton.bind(this));

    // click anywhere else in page to close
    $(document).on('click' + this.namespace, function () {
      $('.link-dropdown__button[aria-expanded="true"]').trigger('click');
    });
  };

  this.onSectionUnload = function (container) {
    this.$container.off(this.namespace);
    $(document).off(this.namespace);
  };
}();
theme.Sections.register('blog-template', theme.BlogTemplateSection, { deferredLoad: false });